<headerCustom></headerCustom>

<sidebarWrapper></sidebarWrapper>

<div class="main-content">
  <div class="adduserContainer">
    <div class="pageContentWrapper">
      <div class="pageHeading">
        <div class="row">
          <div class="col-6">
            <div class="headerName">
              <h3>Interested Applicant</h3>
              <app-breadcrumb></app-breadcrumb>
            </div>
          </div>
          <div class="col-6 addUserButton text-right">
            <div class="row">
              <div class="col-12"></div>
            </div>
          </div>
        </div>
      </div>
      <div class="addUserButtonTableData" *ngIf="interesteNominee.length == 0">
        <div
          class="addUserFormLayout customizeRtsScrollBar addUserFormContainer"
        >
          <table datatable class="table rTsCustomizeTable">
            <thead>
              <tr>
                <th>S.No.</th>
                <th style="min-width:81px">Emp Code</th>
                <th>Employee Name</th>
                <th>Email id</th>
                <!-- <th>Type of Resource</th> -->
                <th>Current Role</th>
                <th>Next Role</th>
                <th>Status</th>
                <th style="min-width:110px">Nominated At</th>
                <th data-orderable="false">View</th>
              </tr>
            </thead>
            <tbody class="text-center"></tbody>
          </table>
        </div>
      </div>
      <div class="addUserButtonTableData" *ngIf="interesteNominee.length > 0">
        <div
          class="addUserFormLayout customizeRtsScrollBar addUserFormContainer"
        >
          <table datatable class="table rTsCustomizeTable">
            <thead>
              <tr>
                <th>S.No.</th>
                <th style="min-width:81px">Emp Code</th>
                <th>Emp Name</th>
                <th>Email id</th>
                <!-- <th>Type of Resource</th> -->
                <th>Current Role</th>
                <th>Next Role</th>
                <th>Status</th>
                <th style="min-width:110px">Nominated At</th>
                <th data-orderable="false">View</th>
              </tr>
            </thead>
            <tbody class="text-center">
              <ng-container
                *ngFor="let element of interesteNominee; let i = index"
              >
                <tr>
                  <td>
                    <div>{{ i + 1 }}</div>
                  </td>
                  <td class="addUserName">
                    <div>{{ element.empCode }}</div>
                  </td>
                  <td class="userSelectType">
                    <div>{{ element.userName }}</div>
                  </td>
                  <td>
                    <div>{{ element.email }}</div>
                  </td>
                  <td>
                    <div>{{ element.CurrentPositionName }}</div>
                  </td>
                  <td>
                    <div>{{ element.NextPositionName }}</div>
                  </td>
                  <td>
                    <div
                      [ngStyle]="{
                        color:
                          element.isApproved == 0
                            ? 'red'
                            : element.isApproved == 1
                            ? 'green'
                            : 'black'
                      }"
                    >
                      <!-- {{element.isApproved==0?'Rejected':element.isApproved==1?'Approved':'Submitted'}} -->
                      {{ commonService.getUserStatus(element.isApproved) }}
                    </div>
                  </td>
                  <td>
                    <div>
                      {{ element.approvedAt ? element.approvedAt : "NA" }}
                    </div>
                  </td>
                  <td class="addUserButtons">
                    <div>
                      <button
                        class="btn form-group hvr-bounce-to-top"
                        title="View"
                        data-toggle="modal"
                        data-target="#viewApplicantDetails"
                        (click)="
                          onclickViewNomineeUserData(
                            element.towerId,
                            element.userId,
                            i
                          )
                        "
                      >
                        <!-- <img src="assets/funRating.png" style="margin-left: 2px; width:0.9rem;" /> -->
                        <i class="fa fa-eye"></i>
                      </button>
                    </div>
                  </td>
                </tr>
              </ng-container>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</div>

<div class="loader" *ngIf="loading">
  <div class="lds-roller">
    <!-- <img src="assets/preloader.gif" />
    <span>Wait...</span> -->
    <div></div>
    <div></div>
    <div></div>
    <div></div>
    <div></div>
    <div></div>
    <div></div>
    <div></div>
  </div>
</div>

<div
  *ngIf="showHideModel"
  class="modal fade"
  id="viewApplicantDetails"
  tabindex="-1"
  role="dialog"
  aria-labelledby="adduserPopContainer"
  aria-hidden="true"
>
  <div class="modal-dialog modal-dialog-centered" role="document">
    <form>
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">Applicant Detail Form</h5>
          <button
            type="button"
            #closeApproveModel1
            class="close"
            data-dismiss="modal"
            aria-label="Close"
          >
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body">
          <div class="row">
            <div class="col-md-6">
              <div class="form-group">
                <label for="empCode" class="col-form-label control-label"
                  >Employee Name</label
                >
                <div>
                  <input
                    type="text"
                    placeholder=""
                    class="form-control"
                    value="{{ viewNominatedData.userName }}"
                    disabled
                  />
                </div>
              </div>
            </div>
            <div class="col-md-6">
              <div class="form-group">
                <label for="empCode" class="col-form-label control-label"
                  >Email Id</label
                >
                <div>
                  <input
                    type="text"
                    placeholder=""
                    class="form-control"
                    value="{{ viewNominatedData.email }}"
                    disabled
                  />
                </div>
              </div>
            </div>
            <div class="col-md-6">
              <div class="form-group">
                <label for="empCode" class="col-form-label control-label"
                  >Current Role</label
                >
                <div>
                  <input
                    type="text"
                    placeholder=""
                    class="form-control"
                    value="{{ viewNominatedData.CurrentPositionName }}"
                    disabled
                  />
                </div>
              </div>
            </div>
            <div
              class="col-md-6"
              [class]="viewNominatedData?.isNextTowerSame ? 'd-none' : ''"
            >
              <div class="form-group">
                <label for="ascasc" class="col-form-label control-label"
                  >Next IBU</label
                >
                <div>
                  <select
                    id="form-ibu"
                    class="form-control"
                    (change)="onChangeIBU($event)"
                  >
                    <option value="">Select IBU</option>
                    <ng-container *ngFor="let ibuItem of ibuList">
                      <option value="{{ ibuItem.ibuId }}">
                        {{ ibuItem.ibuName }}
                      </option>
                    </ng-container>
                  </select>
                </div>
              </div>
            </div>
            <div
              class="col-md-6"
              [class]="viewNominatedData?.isNextTowerSame ? 'd-none' : ''"
            >
              <div class="form-group">
                <label for="fwefwef" class="col-form-label control-label"
                  >Next Function</label
                >
                <div>
                  <select
                    class="form-control"
                    id="form-function"
                    (change)="onChangeFunction($event)"
                  >
                    <option value="">Select Function</option>
                    <ng-container *ngFor="let functionItem of functionList">
                      <option value="{{ functionItem.functionId }}">
                        {{ functionItem.functionName }}
                      </option>
                    </ng-container>
                  </select>
                </div>
              </div>
            </div>

            <!-- <div class="col-md-6">
                            <div class="form-group">
                                <label for="testiuius" class="col-form-label control-label">Tower</label>
                                <div>
                                    {{ test(selectedTowerId)}}
                                    <select class="form-control"  [(ngModel)]="selectedTowerId">
                                        <option value="null">Select Tower</option>
                                        <ng-container *ngFor="let towerItem of towerList">
                                            <option  value="{{towerItem.towerId}}"  >{{ towerItem.towerId }}</option>
                                        </ng-container>
                                    </select>
                                </div>
                            </div>
                        </div> -->
            <div
              class="col-md-6"
              [class]="viewNominatedData?.isNextTowerSame ? 'd-none' : ''"
            >
              <div class="form-group">
                <label for="wfefwef" class="col-form-label control-label"
                  >Next Tower</label
                >
                <div>
                  <select
                    class="form-control"
                    id="form-tower"
                    (change)="onChangeTower($event)"
                  >
                    <option value="">Select Tower</option>
                    <ng-container *ngFor="let towerItem of towerList">
                      <option value="{{ towerItem.towerId }}">
                        {{ towerItem.towerName }}
                      </option>
                    </ng-container>
                  </select>
                </div>
              </div>
            </div>

            <div class="col-md-6">
              <div class="form-group">
                <label for="empCode" class="col-form-label control-label"
                  >Next Role</label
                >
                <div>
                  <select
                    class="form-control"
                    id="form-next-role"
                    (change)="onSelectNextRole($event)"
                  >
                    <option value="">Select Next Role</option>
                    <ng-container *ngFor="let position of positionList">
                      <option
                        value="{{ position.positionId }}"
                        [selected]="position.positionId == nextRole"
                      >
                        {{ position.positionName }}
                      </option>
                    </ng-container>
                    <option value="null">Other</option>
                  </select>
                </div>
              </div>
            </div>
            <!-- If next role have no value and have otherNextRole then this field show -->
            <div class="col-md-6" *ngIf="showOtherNextRole">
              <div class="form-group">
                <label for="empCode" class="col-form-label control-label"
                  >Other Next Role</label
                >
                <div>
                  <input
                    type="text"
                    placeholder=""
                    class="form-control"
                    [value]="viewNominatedData.otherNextPosition"
                    disabled
                  />
                </div>
              </div>
            </div>
            <div class="col-md-6">
              <div class="form-group">
                <label for="empCode" class="col-form-label control-label"
                  >Exp. in Current Role (in Months.)</label
                >
                <div>
                  <input
                    type="text"
                    placeholder=""
                    class="form-control"
                    value="{{ viewNominatedData.experience }}"
                    disabled
                  />
                </div>
              </div>
            </div>
            <div class="col-md-6">
              <div class="form-group">
                <label for="empCode" class="col-form-label control-label"
                  >Latest BSC Score (H1 / H2)</label
                >
                <div>
                  <input
                    type="text"
                    placeholder=""
                    class="form-control"
                    value="{{ viewNominatedData.lastBSC }}"
                    disabled
                  />
                </div>
              </div>
            </div>
            <div class="col-md-12">
              <div class="form-group">
                <label for="empCode" class="col-form-label control-label"
                  >Why you want to move to next role?</label
                >
                <div>
                  <textarea
                    class="form-control"
                    rows="3"
                    cols="63"
                    placeholder=""
                    value="{{ viewNominatedData.whyMove }}"
                    disabled
                  ></textarea>
                </div>
              </div>
            </div>
            <div
              class="col-md-12"
              *ngIf="viewNominatedData.isApproved == 1 ? true : false"
            >
              <div class="form-group">
                <label for="empCode" class="col-form-label control-label"
                  >Why approved</label
                >
                <div>
                  <textarea
                    class="form-control"
                    rows="3"
                    cols="63"
                    placeholder=""
                    value="{{ viewNominatedData.whyApprove }}"
                    disabled
                  ></textarea>
                </div>
              </div>
            </div>
            <div
              class="col-md-12"
              *ngIf="viewNominatedData.isApproved == 0 ? true : false"
            >
              <div class="form-group">
                <label for="empCode" class="col-form-label control-label"
                  >Why rejected?</label
                >
                <div>
                  <textarea
                    class="form-control"
                    rows="3"
                    cols="63"
                    placeholder=""
                    value="{{ viewNominatedData.whyApprove }}"
                    disabled
                  ></textarea>
                </div>
              </div>
            </div>

            <div class="col-md-12">
              <ul class="nav nav-pills float-right">
                <li
                  class="active mr-15"
                  *ngIf="
                    viewNominatedData.isApproved == 0
                      ? true
                      : viewNominatedData.isApproved == 1
                      ? false
                      : true
                  "
                >
                  <a data-toggle="pill" href="#home" (click)="toggle(1)"
                    >Approve</a
                  >
                </li>
                <li
                  *ngIf="
                    viewNominatedData.isApproved == 1
                      ? true
                      : viewNominatedData.isApproved == 0
                      ? false
                      : true
                  "
                >
                  <a data-toggle="pill" href="#menu1" (click)="toggle(2)"
                    >Reject</a
                  >
                </li>
              </ul>

              <div class="tab-content" [formGroup]="myGroup">
                <div
                  id="home"
                  class="tab-pane fade"
                  *ngIf="
                    viewNominatedData.isApproved == 0
                      ? true
                      : viewNominatedData.isApproved == 1
                      ? false
                      : true
                  "
                >
                  <div class="form-group">
                    <label for="empCode" class="col-form-label control-label"
                      >Why you want to approve? *</label
                    >
                    <div>
                      <!-- //<textarea rows="3" cols="63" class="form-control mt-15" placeholder=""></textarea> -->
                      <textarea
                        rows="5"
                        cols="63"
                        class="form-control mt-15"
                        [(ngModel)]="fromApprove"
                        onKeyPress="if(this.value.length > 500) return false;"
                        (input)="onTextChange()"
                        (onpaste)="onTextChange()"
                        formControlName="fromApprove"
                        placeholder=""
                      ></textarea>
                      <label
                        ><span style="color: red">
                          {{ maxLeftCharacterWhyToMove }} characters left out of
                          Maximum : {{ maxCharForWhyToMoveLength }}</span
                        >
                      </label>
                    </div>
                  </div>
                  <div class="appRejBtn pad-rb">
                    <button
                      class="btn hvr-bounce-to-top"
                      (click)="onClickAprvNRjct()"
                      title="OK"
                    >
                      OK
                    </button>
                  </div>
                </div>
                <div
                  id="menu1"
                  class="tab-pane fade"
                  *ngIf="
                    viewNominatedData.isApproved == 1
                      ? true
                      : viewNominatedData.isApproved == 0
                      ? false
                      : true
                  "
                >
                  <div class="form-group">
                    <label for="empCode" class="col-form-label control-label"
                      >Why you want to reject? *</label
                    >
                    <div>
                      <textarea
                        rows="3"
                        cols="63"
                        class="form-control mt-15"
                        formControlName="formReject"
                        placeholder=""
                      ></textarea>
                    </div>
                  </div>
                  <div class="appRejBtn pad-rb">
                    <button
                      class="btn hvr-bounce-to-top"
                      (click)="onClickAprvNRjct()"
                      title="OK"
                    >
                      OK
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </form>
  </div>
</div>

<div class="loader" *ngIf="loading">
  <div class="lds-roller">
    <div></div>
    <div></div>
    <div></div>
    <div></div>
    <div></div>
    <div></div>
    <div></div>
    <div></div>
  </div>
</div>
